import React from 'react'
import classNames from 'classnames'

import { SearchSmallIcon } from 'components/Utils/Icons'
import { quickSwitch as searchShorcut } from 'helpers/ShortcutHelpers'

export default class QuickSwitchRow extends React.PureComponent {
  render() {
    const {
      isHovered,
      onMouseOver,
      onMouseLeave,
      onClick,
      inputCustomStyle = {},
    } = this.props

    return (
      <div
        className={classNames(
          'sidebar-search flexbox flexbox-align-center flexbox-grow padding-horizontal-small padding-vertical-small',
          'pointer no-outline transition',
          'position-relative shade-20 shade-10-on-hover background-shade-50 background-shade-45-on-active radius-normal'
        )}
        style={{ ...inputCustomStyle }}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
      >
        <SearchSmallIcon className="margin-right-small" size={16} />
        <span className="flexbox-grow font-weight-medium">Find anything</span>
        {searchShorcut.map(key => (
          <span
            key={key}
            className={classNames(
              'line-height-one bold font-size-normal margin-left-smaller',
              { 'opacity-null': !isHovered }
            )}
          >
            {key}
          </span>
        ))}
      </div>
    )
  }
}
